module.exports = __webpack_public_path__ + "static/media/blueMan.33401cb6.png";